import styled from 'styled-components';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

const addExamFormMain = {
  horizontalPadding: {
    iphone: 28,
  },
};

const contentItemLabel = {
  width: {
    wxgaPlus: 120,
    uxga: 136,
  },
  paddingRight: {
    wxgaPlus: 16,
  },
};

export const AddExamFormOrthacStyle = styled.form`
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }

    50% {
      transform: rotate(-180deg);
    }

    100% {
      transform: rotate(-360deg);
    }
  }

  background-color: ${colors.mostlyWhite};
  border-radius: 12px;

  &:not(:last-child) {
    margin-bottom: 60px;
  }

  &.show-less {
    .add-exam-form-main,
    .add-exam-series-list,
    .add-exam-button-container {
      max-height: 0;
      opacity: 0;
      padding-bottom: 0;
      padding-top: 0;
      transition: max-height 300ms, padding 300ms, opacity 200ms;
    }
  }

  .add-exam-form-header {
    ${fontFamily.sourceSansPro.bold}
    align-items: center;
    color: ${colors.veryDarkGrayishBlue};
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    line-height: 18px;
    padding: 16px 28px;

    .add-exam-id {
      flex-basis: 32px;
      margin-right: 8px;
    }

    .add-exam-patient-name {
      flex-basis: 50%;
      margin-right: 8px;
    }

    .add-exam-preview-status {
      flex-basis: 50%;
      text-align: right;
    }
  }

  .add-exam-form-main {
    background-color: ${colors.veryPaleBlue};
    border-radius: 12px;
    max-height: 9999em;
    opacity: 1;
    overflow: hidden;
    padding: 16px ${addExamFormMain.horizontalPadding.iphone}px 24px;
    transition: max-height 400ms, padding 200ms, opacity 200ms;

    @media (min-width: ${breakpoints.hd.width}px) {
      display: flex;
    }

    .form-content-column {
      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: 50%;
      }

      &:nth-child(2n + 1) {
        @media (min-width: ${breakpoints.hd.width}px) {
          padding-right: ${addExamFormMain.horizontalPadding.iphone / 2}px;
        }
      }

      &:nth-child(2n + 2) {
        @media (min-width: ${breakpoints.hd.width}px) {
          padding-left: ${addExamFormMain.horizontalPadding.iphone / 2}px;
        }
      }

      &:not(:last-child) {
        margin-bottom: 32px;

        @media (min-width: ${breakpoints.hd.width}px) {
          margin-bottom: 0;
        }
      }

      .form-content-row {
        @media (min-width: ${breakpoints.ipad.width}px) {
          display: flex;
        }

        &:last-child {
          .form-content-item {
            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .form-content-item {
          margin-bottom: 20px;

          @media (min-width: ${breakpoints.ipad.width}px) {
            flex-basis: 50%;
            width: 50%;
          }

          &:nth-child(2n + 1) {
            @media (min-width: ${breakpoints.ipad.width}px) {
              padding-right: 8px;
            }
          }

          &:nth-child(2n + 2) {
            @media (min-width: ${breakpoints.ipad.width}px) {
              padding-left: 8px;
            }
          }
        }
      }

      .form-content-item {
        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }

      .content-title {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.veryDarkGray};
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
      }

      .form-content-item {
        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          align-items: center;
          display: flex;
        }

        .content-item-label {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.veryDarkGray};
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 8px;

          @media (min-width: ${breakpoints.wxgaPlus.width}px) {
            flex-basis: ${contentItemLabel.width.wxgaPlus}px;
            margin-bottom: 0;
            min-width: ${contentItemLabel.width.wxgaPlus}px;
            padding-right: ${contentItemLabel.paddingRight.wxgaPlus}px;
          }

          @media (min-width: ${breakpoints.uxga.width}px) {
            flex-basis: ${contentItemLabel.width.uxga}px;
            min-width: ${contentItemLabel.width.uxga}px;
          }
        }

        .content-item-input {
          width: 100%;

          @media (min-width: ${breakpoints.wxgaPlus.width}px) {
            flex-basis: calc(
              100% -
                (
                  ${contentItemLabel.width.wxgaPlus +
                  contentItemLabel.paddingRight.wxgaPlus}
                )
                px
            );
          }

          @media (min-width: ${breakpoints.uxga.width}px) {
            flex-basis: calc(
              100% -
                (
                  ${contentItemLabel.width.uxga +
                  contentItemLabel.paddingRight.wxgaPlus}
                )
                px
            );
          }
        }
      }
    }
  }

  .add-exam-series-list {
    max-height: 9999em;
    opacity: 1;
    overflow: hidden;
    padding: 24px 28px 0;
    transition: max-height 400ms, padding 200ms, opacity 200ms;

    .add-exam-serie-container {
      &:not(:last-child) {
        @media (min-width: ${breakpoints.hd.width}px) {
          margin-bottom: 16px;
        }
      }
    }
  }

  .add-exam-series-list-loading {
    padding: 24px 28px 48px;

    .loading-wrapper {
      display: block;
      margin: 0 auto 16px;
      width: 40px;

      svg {
        animation: rotate 800ms infinite linear;
        display: block;
        fill: ${colors.softBlue};
        height: auto;
        width: 100%;
      }
    }

    .series-list-loading-message {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.softBlue};
      font-size: 14px;
      line-height: 18px;
      padding: 0 16px;
      text-align: center;
    }
  }

  .add-exam-button-container {
    max-height: 9999em;
    opacity: 1;
    overflow: hidden;
    padding: 48px 28px 48px 0;
    text-align: right;
    transition: max-height 400ms, padding 200ms, opacity 200ms;

    .button-wrapper {
      display: inline-block;
      max-width: 284px;
      width: 100%;
    }
  }
`;
